module.exports = __webpack_public_path__ + "img/token__disable.2fe6fc18.svg";